import React, { useEffect, useState } from 'react';
import SaveModal from '../modal/saveModal';

function IssueRequest() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    
    const isLocal = window.location.hostname != 'wpal.philippineair.co.kr';
    const domain = isLocal ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_PRODUCTION_API_URL;
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get('token');
    useEffect(() => {
        if (!token || token.length != 36) {
            setModalContent('404 NOT FOUND');
            setSaveStatus(false);
            setModalAction(() => () => {
                window.location.href = '/';
            })
            return null
        }
        
    },[])

    // const domain = 'https://philippineair-admin-nod-series-dce0ckhbcwged7f9.koreacentral-01.azurewebsites.net'

    const iframeSrc = `${domain}/public/wpal/issue-request?token=${token || ''}`;

    return (
        <div >
            {!token ? 
                <></> : 
                <iframe
                    src={`${iframeSrc}`}
                    style={{ width: '100%', height: 'calc(-0px + 99vh)' }}
                ></iframe>
            }
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default IssueRequest;
